import { type Country, type StateCode } from '~/vendor/cx-modules/types';

export type OddsClickParams = {
  betId: number;
  bookmakerCode: string;
  countryCode: Country;
  repub: string;
  subdivisionCode: StateCode | '';
};

export const ODDS_CLICK_PATH = '/api/cx/sports-catalogue/v1/odds-click';

/**
 * Fire-and-forget odds-click beacon, sent whenever a bet is added to the betslip.
 *
 * It lives here rather than in `@cx-web/feature-betslip` because OC does not run that betslip — it
 * runs the legacy CDN widget, and its two bridges (`useUkCdnBetslip`, product-plus's
 * `useOCRepubBetslip`) must send the identical beacon or the repub is never counted.
 *
 * `keepalive`: adding a bet is routinely followed straight away by a clickout.
 */
export function postOddsClick({ betId, bookmakerCode, countryCode, repub, subdivisionCode }: OddsClickParams): void {
  if (typeof fetch === 'undefined') return;

  fetch(ODDS_CLICK_PATH, {
    body: JSON.stringify({ betId, bookmakerCode }),
    headers: {
      'content-type': 'application/json',
      'country-code': countryCode,
      repub,
      'subdivision-code': subdivisionCode,
    },
    keepalive: true,
    method: 'POST',
  }).catch(() => {});
}
